module.exports = __webpack_public_path__ + "img/closed-eye.7cc1e217.png";